import { Grid, TextField, Typography, FormHelperText, Box } from "@mui/material";
import { FieldControl } from "../../../../shared/components";
import { useDisplayField } from "../../../../hooks/useDisplayField";
import { RichText } from "../RichText/RichText";

export const Agenda = ({ meetingData, onChange, errors = {} }: { meetingData: any, onChange: (key: string, value: any) => void, errors?: { [key: string]: string } }) => {

    const { getFilterOptions } = useDisplayField([]);

    return (
        <Grid container spacing={2}>
            <Grid size={12}>
                <FieldControl
                    variant="select"
                    keyName="meeting_category"
                    label="Meeting Category"
                    options={getFilterOptions('MEETING_CATEGORY').map((value) => ({
                        value: value.key,
                        label: value.display_text
                    }))}
                    value={meetingData.meeting_category}
                    onChange={(_key: string, value: string) => {
                        onChange('meeting_category', value);
                        onChange('meeting_template', getFilterOptions('MEETING_TEMPLATE').find((t) => t.parent_key === value)?.key || '');
                    }}
                    error={!!errors.meeting_category}
                    helperText={errors.meeting_category}
                    required
                />
            </Grid>
            {meetingData.meeting_category !== 'ADHOC_MEETING' && (
                <Grid size={12}>
                    <TextField
                        fullWidth
                        label="Meeting Template"
                        value={getFilterOptions('MEETING_TEMPLATE').find((t) => t.key === meetingData.meeting_template)?.display_text || ''}
                        error={!!errors.meeting_template}
                    />
                </Grid>
            )}
            {meetingData.meeting_category !== 'ADHOC_MEETING' && (
                <Grid size={12}>
                    <Box>
                        <Typography
                            variant="subtitle2"
                            component="div"
                            sx={{ mb: 1 }}
                        >
                            Meeting Agenda
                        </Typography>
                        <RichText
                            content={getFilterOptions('MEETING_TEMPLATE').find((t) => t.key === meetingData.meeting_template)?.helper_text}
                            editable={false}
                        />
                        {errors.agenda && (
                            <FormHelperText error sx={{ ml: 2, mt: 1 }}>
                                {errors.agenda}
                            </FormHelperText>
                        )}
                    </Box>
                </Grid>
            )}
            <Grid size={12}>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="Additional Points"
                    variant="outlined"
                    value={meetingData.additional_points}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange('additional_points', e.target.value)}
                />
            </Grid>
        </Grid>
    );
}